import React, { useEffect, useState } from 'react';
import { CheckCircle2, XCircle, AlertTriangle, Info, X } from 'lucide-react';

let listener = null;
let idc = 0;
let last = { message: '', at: 0 };

const push = (type, message, opts = {}) => {
  if (!listener) return;
  const now = Date.now();
  if (last.message === String(message) && now - last.at < 1500) return;
  last = { message: String(message), at: now };
  const description = typeof opts === 'object' && opts !== null ? opts.description : undefined;
  const duration = (typeof opts === 'object' && opts !== null && opts.duration) || 5000;
  listener({ id: ++idc, type, message: String(message), description, duration });
};

export const toast = {
  success: (m, o) => push('success', m, o),
  error: (m, o) => push('error', m, o),
  warning: (m, o) => push('warning', m, o),
  info: (m, o) => push('info', m, o),
  dismiss: () => { if (listener) listener({ clear: true }); },
};

const STYLES = {
  success: { box: 'border-emerald-300 bg-emerald-50', icon: CheckCircle2, iconCls: 'text-emerald-600', text: 'text-emerald-900' },
  error: { box: 'border-red-300 bg-red-50', icon: XCircle, iconCls: 'text-red-600', text: 'text-red-900' },
  warning: { box: 'border-amber-300 bg-amber-50', icon: AlertTriangle, iconCls: 'text-amber-600', text: 'text-amber-900' },
  info: { box: 'border-blue-300 bg-blue-50', icon: Info, iconCls: 'text-blue-600', text: 'text-blue-900' },
};

export function WorkflowNotices() {
  const [notices, setNotices] = useState([]);

  useEffect(() => {
    listener = (n) => {
      if (n.clear) { setNotices([]); return; }
      setNotices([n]);
      setTimeout(() => {
        setNotices((prev) => prev.filter((x) => x.id !== n.id));
      }, n.duration);
    };
    return () => { listener = null; };
  }, []);

  if (notices.length === 0) return null;
  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center pointer-events-none" data-testid="workflow-notices">
      <div className="flex flex-col gap-3 items-center w-full max-w-lg px-4">
        {notices.map((n) => {
          const s = STYLES[n.type] || STYLES.info;
          const Icon = s.icon;
          return (
            <div
              key={n.id}
              className={`pointer-events-auto w-full rounded-xl border-2 shadow-2xl p-4 flex items-start gap-3 animate-in fade-in zoom-in-95 ${s.box}`}
              data-testid={`workflow-notice-${n.type}`}
            >
              <Icon className={`w-6 h-6 flex-shrink-0 mt-0.5 ${s.iconCls}`} />
              <div className={`flex-1 min-w-0 text-sm font-medium ${s.text}`}>
                <p className="whitespace-pre-line">{n.message}</p>
                {n.description && <p className="text-xs font-normal opacity-80 mt-1">{n.description}</p>}
              </div>
              <button
                onClick={() => setNotices((prev) => prev.filter((x) => x.id !== n.id))}
                className={`flex-shrink-0 p-1 rounded-md hover:bg-black/5 ${s.text}`}
                data-testid="workflow-notice-close"
                aria-label="Close notification"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
